import { STATUS_PUBLICACAO } from './../../config/status-publicacao.config';
import { NoticiaDTO } from '../../models/site/noticiaDTO';
import { API_CONFIG } from './../../config/api.config';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NoticiaService {

  constructor(private http: HttpClient){ 
  }

  insert(noticiaDTO: NoticiaDTO) : Observable<any> {
    

    return this.http.post<any>( API_CONFIG.apiURL+'/noticias'
                              , noticiaDTO
                              , { observe: 'response' }); //.pipe(timeout(100000))

  }

  update(noticiaDTO: NoticiaDTO) : Observable<any> {
    
    return this.http.put<any>( API_CONFIG.apiURL+'/noticias/' + noticiaDTO.id
                             , noticiaDTO
                             , { observe: 'response' });

  }


  findAll() : Observable<NoticiaDTO[]> {

    return this.http.get<NoticiaDTO[]>( API_CONFIG.apiURL+'/noticias');

  }

  findByFilter( filtroTexto: string
              , filtrarTitulo: boolean
              , filtrarSubtitulo: boolean
              , filtrarResumo: boolean
              , filtrarTexto: boolean
              , page: number
              , pageSize: number
              , sort: string = 'ASC') : Observable<NoticiaDTO[]> {

    return this.http.get<NoticiaDTO[]>( API_CONFIG.apiURL+'/noticias/findByFilter?filtroTexto='+filtroTexto+
                                                                                 '&filtrarTitulo='+filtrarTitulo+
                                                                                 '&filtrarSubtitulo='+filtrarSubtitulo+
                                                                                 '&filtrarResumo='+filtrarResumo+
                                                                                 '&filtrarTexto='+filtrarTexto+
                                                                                 '&page='+page+
                                                                                 '&size='+pageSize+
                                                                                 '&sort='+sort);

  }

  findByStatus(status: string) : Observable<NoticiaDTO[]> {
    
    return this.http.get<NoticiaDTO[]>( API_CONFIG.apiURL+'/noticias/findByStatus?status='+status);

  }

  
  find(id: number) : Observable<NoticiaDTO> {

    return this.http.get<NoticiaDTO>( API_CONFIG.apiURL+'/noticias/' + id);

  }

  delete(id: number) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/noticias/'}${id}`);

  }

  getTextoResumido(noticia: NoticiaDTO): string{
    if(!noticia.texto){
      return '';
    }
  
    return noticia.texto.substring(0, noticia.texto.indexOf('.')+1);
  }


  getStatusPublicacaoFormatado(status: string): string{
    
    if(status===STATUS_PUBLICACAO.PRONTO_PARA_PUBLICAR){
      return "Pronta para publicar";
    }else if(status===STATUS_PUBLICACAO.PUBLICADO){
      return "Publicada";
    }else if(status===STATUS_PUBLICACAO.RASCUNHO){
      return "Rascunho";
    }

    return 'Status desconhecido';
  }
  
  
  

}
